import AxiosServices from "./AxiosServices";
import { URL } from "../config/URL.Config";
const instance = new AxiosServices().getServiceInstance();
export const getApplicationByAppSpecificId = async (id: string) => {
  const res = await instance.get(
    URL.application.getApplicationByAppSpecificIdAsync(id)
  );
  return res.data.data;
};
